"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _propTypes = require("prop-types");

var _font = _interopRequireDefault(require("../shared/font"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Wrapper = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e6aky3h0"
})(_font.default, ";display:grid;grid-template-rows:repeat(6,40px);grid-template-columns:repeat(auto-fit,minmax(300px,1fr));grid-gap:30px;margin-top:", function (props) {
  return props.small ? 0 : '50px';
}, ";");
var Card = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e6aky3h1"
})("background-color:", function (props) {
  return props.background || '#fefffe';
}, ";border-radius:2px;display:flex;justify-content:center;flex-direction:column;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);padding:25px;position:relative;grid-row:", function (props) {
  return props.row ? "span " + props.row : 'span 3';
}, ";h3{color:", function (props) {
  return props.color || '#424242';
}, ";}p{width:100%;color:", function (props) {
  return props.color || '#424242';
}, ";font-size:14px;line-height:22px;padding-top:", function (props) {
  return props.small ? 0 : '60px';
}, ";}");
var Author = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e6aky3h2"
})("display:flex;flex-direction:row;justify-content:space-between;position:", function (props) {
  return props.small ? 'static' : 'absolute';
}, ";width:", function (props) {
  return props.small ? '100%' : 'calc(100% - 50px)';
}, ";top:25px;img{border-radius:50%;height:50px;width:50px;}& > div{width:", function (props) {
  return props.small ? '100%' : 'calc(100% - 70px)';
}, ";text-align:left;h3{margin:4px 0 2px;font-size:16px;}p{margin:0;padding:0;}}");

var Testimonial = /*#__PURE__*/function (_Component) {
  function Testimonial() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Testimonial.prototype;

  _proto.render = function render() {
    return _react.default.createElement(Wrapper, null, this.props.children);
  };

  _inheritsLoose(Testimonial, _Component);

  return Testimonial;
}(_react.Component);

exports.default = Testimonial;

_defineProperty(Testimonial, "Card", function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(Card, props, _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      small: props.small ? 1 : 0
    });
  }));
});

_defineProperty(Testimonial, "Author", function (_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react.default.createElement(Author, props, children);
});

Testimonial.propTypes = {
  children: _propTypes.node
};